import { createSlice } from "@reduxjs/toolkit";

export const NOTIFICATION_SLICE_NAME = "notification";

export const notificationInitialState = {
  open: false,
  type: "info",
  message: "",
  timeout: 4000,
};

export const NotificationSlice = createSlice({
  name: NOTIFICATION_SLICE_NAME,
  initialState: notificationInitialState,
  reducers: {
    addNotification: (_state, action) => ({
      ...notificationInitialState,
      ...action.payload,
      open: true,
    }),
    clearNotification: (state) => ({ ...state, open: false }),
  },
});
export const NotificationActions = NotificationSlice.actions;

export default NotificationSlice.reducer;
